const {migrateStructuredMegaMenuSubmenu} = require('./migration')

module.exports = {
    migrateStructuredMegaMenuSubmenu
}
